import { render, staticRenderFns } from "./empty-mask-layer.vue?vue&type=template&id=60018094&scoped=true&"
import script from "./empty-mask-layer.vue?vue&type=script&lang=js&"
export * from "./empty-mask-layer.vue?vue&type=script&lang=js&"
import style0 from "./empty-mask-layer.vue?vue&type=style&index=0&id=60018094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60018094",
  null
  
)

export default component.exports